"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _isNumber = _interopRequireDefault(require("lodash/isNumber"));
var _isUndefined = _interopRequireDefault(require("lodash/isUndefined"));
/**
 * Utilities for working with numbers.
 * @module NumberUtils
 */
const NumberUtils = {
  /**
   * Rounds a given number down to the nearest specified number.
   * @static
   * @function roundDownToNearestStep
   * @param {Number} num - The number to round.
   * @param {Number} step - The step to round down to.
   * @example
   * NumberUtils.roundDownToNearestStep(57, 30); // 30
   * NumberUtils.roundDownToNearestStep(161, 15); // 150
   * @returns {Number} - The rounded number.
   */
  roundDownToNearestStep(num, step) {
    if (!(0, _isNumber.default)(num)) {
      throw new Error('You can only round numbers.');
    }
    if ((0, _isUndefined.default)(step)) {
      throw new Error('You must provide a step to round down to.');
    }
    return step * Math.floor(num / step);
  }
};
var _default = exports.default = NumberUtils;